import { COLOR } from './types'

export const white = {
  DEFAULT: COLOR.white_100,
}
